function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.988 14.988A3.435 3.435 0 0 0 16 12.545c0-.923-.36-1.79-1.012-2.443l-3.305-3.306a3.431 3.431 0 0 0-2.444-1.011c-.923 0-1.79.36-2.443 1.011a.532.532 0 0 0 0 .755.533.533 0 0 0 .754 0c.452-.452 1.051-.7 1.69-.7.638 0 1.237.248 1.688.7l3.306 3.305c.45.451.7 1.051.7 1.69 0 .637-.25 1.237-.7 1.688-.452.45-1.051.7-1.689.7a2.373 2.373 0 0 1-1.689-.7L7.55 10.928a.533.533 0 1 0-.754.754l3.306 3.306A3.433 3.433 0 0 0 12.545 16c.923 0 1.79-.36 2.443-1.012z",
  fill: "#1890FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.204 8.45a.533.533 0 0 0-.755 0c-.45.45-1.05.699-1.689.699a2.372 2.372 0 0 1-1.689-.7L1.766 5.143a2.375 2.375 0 0 1-.699-1.688c0-.638.249-1.238.7-1.69.45-.45 1.05-.698 1.688-.698.638 0 1.238.248 1.69.7L8.45 5.071a.533.533 0 1 0 .754-.754L5.898 1.012A3.433 3.433 0 0 0 3.455 0c-.922 0-1.79.36-2.443 1.012A3.435 3.435 0 0 0 0 3.455c0 .923.36 1.79 1.012 2.443l3.306 3.306a3.431 3.431 0 0 0 2.443 1.011c.923 0 1.79-.359 2.443-1.011a.534.534 0 0 0 0-.755z",
  fill: "#1890FF"
});

function SvgCompound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompound);
export default __webpack_public_path__ + "static/media/compound.e725584c.svg";
export { ForwardRef as ReactComponent };